module.exports = __webpack_public_path__ + "img/shoppingOrder.92585c52.png";